<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
const defaultFavicon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAXNJREFUeNrsV9GNwjAMDdYN0A/4Z4QyAWUDNiidhHYS6AZs0GOCdgT+4YMRsJFdWT4qXe+SFqE+yYqUWnkvjlPHM/cCi/kiwSFF26JF7n+4o53Qyuvt+m0/zgzxEocDWuLCgARkKOTyQwCSxzhUL3bc8C4sYuV7YbOI2M9GZIMimlYA77w25AXaUas10apUpAr0yzv8aO0d2t6IWNHawBMHRS4f8y7yPqA1WNxKRTJiTgeccPrM2/D4BK+5UVMJcQNnu1OhbAIloIgo1FQKfNUERxcemmML6uwbH2f+m5zgm/XMBTCZORRaLnAjYxIwuoAvT+us8aeS9/Bf+haQ/LWCfswRUJ0/9/BP5Rh8CTh3leOOEr0WAdM1nASAeUAOhUgLkNIY8wMyKJhDXsp34KZBsBtg95rjRAJKNbHn/iDU7mPzPC+B2yXdMlUhRKjGp/17ErckYWbe7DVVNx85QWtwpaxN75G9T2v2Fs3pWO35Q4ABAOmHkX85SQ58AAAAAElFTkSuQmCC";

export default {
  name: "App",

  metaInfo() {
    const websiteName = this.websiteName;
    const favicon = this.favicon;
    return {
      title: websiteName,
      htmlAttrs: {
        lang: "en"
      },
      link: [
        {
          rel: "icon",
          href: favicon || defaultFavicon
        }
      ]
    };
  },

  computed: {
    favicon() {
      return this.$store.state.config.favicon;
    },
    websiteName() {
      return this.$store.state.config.name;
    }
  }
};
</script>
